<section class="hero is-link is-fullheight-with-navbar pattern">
  <div class="hero-body">
    <div class="columns is-vcentered">
      <div class="column is-two-thirds">
        <h1 class="title is-1 is-size-2-mobile is-spaced">
          dilo. meet people going out
        </h1>
        <p class="subtitle">
          Find a plan for tonight. Meet new people with similar interests and
          explore cool things to do around you.
        </p>
        <div class="columns">
          <div class="column has-text-centered is-narrow">
            <div class="notification is-primary">
              <a href="https://apps.apple.com/us/app/dilo/id1574622995">
                <img
                  width="200"
                  src="https://d1pnnwteuly8z3.cloudfront.net/images/dafc1e05-b0e8-4c6d-b375-4a62333bbd5a/00f3d09f-0db5-49ce-b063-159e4ec36a58.svg"
                  alt="apple store logo"
                />
              </a>
            </div>
          </div>
          <div class="column has-text-centered is-narrow">
            <div class="notification is-primary">
              <a href="https://play.google.com/store/apps/details?id=chat.dilo">
                <img
                  width="200"
                  src="https://d1pnnwteuly8z3.cloudfront.net/images/dafc1e05-b0e8-4c6d-b375-4a62333bbd5a/9b92921f-27ed-4beb-831b-e91058b0cdfb.svg"
                  alt="google play logo"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="column preview">
        <img src="/preview/chat.png" alt="dilo preview 1" />
      </div>
    </div>
  </div>
</section>

<style>
  .pattern {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 1600 800'%3E%3Cg %3E%3Cpolygon fill='%23526075' points='1600 160 0 460 0 350 1600 50'/%3E%3Cpolygon fill='%235c6a80' points='1600 260 0 560 0 450 1600 150'/%3E%3Cpolygon fill='%2365748a' points='1600 360 0 660 0 550 1600 250'/%3E%3Cpolygon fill='%236f7e95' points='1600 460 0 760 0 650 1600 350'/%3E%3Cpolygon fill='%237888A0' points='1600 800 0 800 0 750 1600 450'/%3E%3C/g%3E%3C/svg%3E");
    /* background-attachment: fixed; */
    background-size: cover;
    /* background by SVGBackgrounds.com */
  }

  .column.preview img {
    border: solid #333d4c 10px;
    border-radius: 60px;
    max-width: 100%;
  }
</style>
